module.exports = __webpack_public_path__ + "static/media/ALL - BLUE.888c2531.svg";